import React from 'react';
import { isMobile } from 'react-device-detect';
import logo from '../../../assets/logo.png';
import { useAuth } from '../../../contexts/AuthContext';
import { SeparationType } from '../../../enums/SeparationType';
import { Breadcrumb, IBreadcrumbItem } from '../../Breadcrumb/Breadcrumb';
import { DropdownButton } from '../../DropdownButton/DropdownButton';
import { Container, Left, Right, Logo, PageInfo, PageTitle } from './styles';

interface IHeaderProps {
  title: string;
  rightContent?: React.ReactNode;
  userMenu?: boolean;
  breadcrumbItems?: IBreadcrumbItem[];
  separationType?: SeparationType;
  version?: number;
  alertSummary?: boolean;
}

export const Header: React.FC<IHeaderProps> = ({
  title,
  rightContent,
  userMenu = true,
  breadcrumbItems,
  separationType,
  version,
  alertSummary
}) => {

  const { session, signOut } = useAuth();

  const memoMenuRender = React.useMemo(() => {
    if (!userMenu) return null;
    return (
      <>
        <DropdownButton
          text={session?.user?.name || 'Usuário'}
          items={[{ text: 'Sair', key: 'signOut' }]}
          clickItem={() => signOut()}
          small={isMobile}
        />
      </>
    )
  }, [userMenu, separationType, version]);

  return (
    <Container>
      <Left>
        <Logo src={logo} alt='Logo Zerezes' />
        <PageInfo>
          <Breadcrumb items={breadcrumbItems} />
          <PageTitle>{title}</PageTitle>
        </PageInfo>
      </Left>
      <Right>
        {rightContent}
        {memoMenuRender}
      </Right>
    </Container>
  );
}